import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import Layout from '../../component/layout'
import { getItem } from '../../../../utils/localStorage';
import { toastify } from '../../../../utils/toast';
import { makeRequest2 } from '../../../../utils/makeRequest';
import { filterObjectsByAllProperties } from '../../../../utils/filterSearch';
import ConfirmDialog from '../../component/confirmDialog';
import { getFacilityReceptionists, editFacilityReceptionist, deleteFacilityReceptionist } from '../../../../utils/urls';

function ReceptionManagement() {
  const navigate = useNavigate()
  const [receptionists, setReceptionists] = useState([])
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [receptionistId, setReceptionistId] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [isConfirmDialogVisible, setConfirmDialogVisible] = useState(false);
  const [selectedReceptionistId, setSelectedReceptionistId] = useState(null);
  const [confirmAction, setConfirmAction] = useState('');

  const fetchReceptionistsForFacility = async () => {
    try {
      const value = await getItem('selectedFacilityId');
      const response = await makeRequest2(`${getFacilityReceptionists}/${value}`, 'GET', {});

      if (response.success) {
        setReceptionists(response.data);
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      console.log(error.message);
      toastify(error.message, 'error');
    }
  };

  const actionTemplate = (rowData) => {

    return (
      <div className="actions">
        <Button
          icon="ti ti-edit"
          className="p-button-rounded p-button-info mr-2"
          onClick={() => handleEdit(rowData)}
          tooltip="Edit"
        />
        <Button
          icon="ti ti-trash"
          className="p-button-rounded p-button-danger mr-2"
          onClick={() => {
            setSelectedReceptionistId(rowData._id);
            setConfirmAction('delete');
            setConfirmDialogVisible(true);
          }}
          tooltip="Delete"
        />
      </div>
    );
  };

  const phoneNumberTemplate = (rowData) => {
    const phone = rowData.phoneNumber;
    return '+254' + phone
  }

  const handleEdit = (rowData) => {
    setReceptionistId(rowData._id);
    setFirstName(rowData.firstName);
    setLastName(rowData.lastName);
    setPhoneNumber(rowData.phoneNumber);
    setEmail(rowData.email);
    setEditDialogVisible(true);
  };

  const HandleEditSubmit = async () => {
    try {
      const facilityId = await getItem('selectedFacilityId')
      const updatedData = {
        firstName,
        lastName,
        phoneNumber,
        email
      };

      const response = await makeRequest2(`${editFacilityReceptionist}/${facilityId}/${receptionistId}`, 'POST', updatedData);

      if (response.success) {
        toastify('Receptionist updated successfully', 'success');
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
        setEmail('');
        setEditDialogVisible(false);
        fetchReceptionistsForFacility();
      } else {
        throw new Error(response.error);
      }
    } catch (err) {
      console.log(err);
      toastify(err.message, 'error');
    }
  };

  const handleDelete = async (receptionistId) => {
    try {
      const facilityId = await getItem('selectedFacilityId')
      const response = await makeRequest2(deleteFacilityReceptionist + '/' + facilityId + '/' + receptionistId, 'POST');

      if (response.success) {
        toastify('Receptionist deleted successfully', 'success');
        fetchReceptionistsForFacility();
      } else {
        throw new Error(response.error);
      }
    } catch (err) {
      toastify(err.message, 'error');
    }
  };

  const handleConfirmAction = async () => {
    setConfirmDialogVisible(false);

    if (confirmAction === 'delete') {
      await handleDelete(selectedReceptionistId);
    }
  };

  const handleInputSearch = async (value) => {
    try {
      setSearchTerm(value);
      if (value === '') {
        fetchReceptionistsForFacility()
      } else {
        const results = await filterObjectsByAllProperties(receptionists, value);
        setReceptionists(results);
      }
    } catch (error) {
      toastify(error.message, 'error');
    }
  };

  useEffect(() => {
    fetchReceptionistsForFacility();
  }, []);

  return (
    <Layout>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/facility/"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"#"}>Visitor & Access Management</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"#"}>Reception Management</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>Reception Management</h5>
                </div>
                <div className='card-body'>
                  <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                      <div className="card">
                        <div className="card-body position-relative">
                          <div className="row">
                            <div className="col-md-3 col-xs-12 mb-3">
                              <input
                                className="form-control"
                                placeholder="Search here"
                                value={searchTerm}
                                onChange={(e) => { handleInputSearch(e.target.value) }}
                              />
                            </div>

                            <div className="col-md-9 col-xs-12 mb-3">
                              <div style={{ float: 'right' }}>
                                <button className='btn btn-primary' onClick={() => navigate('/facility/visitor_access_management/add_receptionist')}>Add Receptionist</button>
                                &nbsp;
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <div className="dt-responsive table-responsive">
                                <DataTable
                                  value={receptionists}
                                  emptyMessage="No Receptionists Found."
                                  sortMode="multiple"
                                  paginator
                                  rows={5}
                                  stripedRows
                                  tableStyle={{ minWidth: '50rem' }}
                                >
                                  <Column field="firstName" header="First Name" />
                                  <Column field="lastName" header="Last Name" />
                                  <Column header="Phone Number" body={phoneNumberTemplate} />
                                  <Column field="email" header="Email" />
                                  <Column body={actionTemplate} header="Actions" />
                                </DataTable>
                                <ConfirmDialog
                                  visible={isConfirmDialogVisible}
                                  onHide={() => setConfirmDialogVisible(false)}
                                  message={`Are you sure you want to ${confirmAction} this receptionist?`}
                                  onConfirm={handleConfirmAction}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog header={`Edit Receptionist Information`} visible={editDialogVisible} onHide={() => { if (!editDialogVisible) return; setEditDialogVisible(false); }}>

        <div className="row">
          <div className="col-md-12 mt-3">
            <div >
              <label className="form-label">First Name<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                className="mb-3 form-control"
                value={firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  setFirstName(value)
                }}
              />
            </div>

            <div >
              <label className="form-label">Last Name<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                className="mb-3 form-control"
                value={lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  setLastName(value)
                }}
              />
            </div>

            <div >
              <label className="form-label">Mobile Number<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                className="mb-3 form-control"
                placeholder="e.g. 712 345 678"
                value={phoneNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  setPhoneNumber(value)
                }}
              />
            </div>

            <div >
              <label className="form-label">Email<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                className="mb-3 form-control"
                placeholder="e.g. reception@example.com"
                value={email}
                onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value)
                }}
              />
            </div>

            <div className='mt-4' style={{ float: 'right' }}>
              <button className="btn btn-primary" onClick={HandleEditSubmit}>Submit</button>
            </div>

          </div>

        </div>

      </Dialog>

    </Layout>
  )
}

export default ReceptionManagement